export default __webpack_public_path__ + "8b2de1b9cb83fabdd0857ec3e9d9e18c.otf";